import { render, staticRenderFns } from "./BasePropTabSignatureSettings.vue?vue&type=template&id=3d12809a&scoped=true&"
import script from "./BasePropTabSignatureSettings.vue?vue&type=script&lang=js&"
export * from "./BasePropTabSignatureSettings.vue?vue&type=script&lang=js&"
import style0 from "./BasePropTabSignatureSettings.vue?vue&type=style&index=0&id=3d12809a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d12809a",
  null
  
)

export default component.exports